// extracted by mini-css-extract-plugin
export var avatarContainer = "_8o-0";
export var avatarTypingWave = "_8o-i";
export var gray = "_8o-f";
export var green = "_8o-c";
export var icon = "_8o-9";
export var image = "_8o-1";
export var lg = "_8o-6";
export var md = "_8o-5";
export var presenceDot = "_8o-b";
export var red = "_8o-d";
export var sm = "_8o-4";
export var status = "_8o-a";
export var typingDot = "_8o-h";
export var typingPill = "_8o-g";
export var xl = "_8o-7";
export var xs = "_8o-3";
export var xxl = "_8o-8";
export var xxs = "_8o-2";
export var yellow = "_8o-e";